export default "__VITE_ASSET__a0075ee7__"